import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/mobile/fi-rr-angle-small-right-white.png'
import _imports_1 from '@/assets/images/mobile/text-share.png'
import _imports_2 from '@/assets/images/mobile/share-image.svg'
import _imports_3 from '@/assets/images/mobile/title-share-section-1.png'
import _imports_4 from '@/assets/images/mobile/gift-blue.png'
import _imports_5 from '@/assets/images/mobile/gift-yellow.png'
import _imports_6 from '@/assets/images/mobile/like-icon-section-1.png'
import _imports_7 from '@/assets/images/mobile/monthly-tab.png'
import _imports_8 from '@/assets/images/mobile/half-year-tab.png'
import _imports_9 from '@/assets/images/mobile/share-title-section-2.png'
import _imports_10 from '@/assets/images/mobile/list-gifts-icon-1.png'


const _hoisted_1 = { class: "container-mobile overflow-auto" }
const _hoisted_2 = { class: "share-header-e d-flex align-items-center" }
const _hoisted_3 = { class: "text-center share-header-e" }
const _hoisted_4 = { class: "content position-relative" }
const _hoisted_5 = { class: "share-image d-flex flex-column align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "title text-white pt-2"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "cn-img pt-2"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "mt-4",
  src: _imports_2,
  alt: "share-image"
}, null, -1)
const _hoisted_9 = { class: "share-content mx-auto pb-3" }
const _hoisted_10 = { class: "section section-1 rounded-3 mb-3 d-flex flex-column align-items-center" }
const _hoisted_11 = { class: "part-1 d-flex justify-content-between flex-wrap text-start" }
const _hoisted_12 = { class: "title-container d-flex align-items-center flex-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "title-section-1 me-1"
}
const _hoisted_14 = {
  key: 1,
  src: _imports_3,
  alt: "本月奖励",
  class: "me-1 title-section-1-img title-section-1"
}
const _hoisted_15 = { class: "months-rewards" }
const _hoisted_16 = { class: "part-2 mt-3 text-start" }
const _hoisted_17 = { class: "invint-text" }
const _hoisted_18 = { class: "sp1" }
const _hoisted_19 = { class: "sp2" }
const _hoisted_20 = { class: "invint-note mt-1" }
const _hoisted_21 = { class: "part-3 mt-1" }
const _hoisted_22 = { class: "progress-constainer rounded-3 position-relative" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_24 = { class: "label position-absolute" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_26 = { class: "label position-absolute" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_28 = { class: "label position-absolute" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_30 = { class: "label position-absolute" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_32 = { class: "label position-absolute" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_34 = { class: "label position-absolute" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "gift",
  class: "gift-img"
}, null, -1)
const _hoisted_36 = { class: "label position-absolute" }
const _hoisted_37 = { class: "section-1-note mt-1 text-start rounded-1 p-1 d-flex align-items-start" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "like-icon me-1",
  alt: "like-icon"
}, null, -1)
const _hoisted_39 = {
  key: 0,
  class: "m-0"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("有效邀请")
const _hoisted_41 = { class: "orange-color" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("人，再邀请")
const _hoisted_43 = { class: "orange-color" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("人可解锁奖励")
const _hoisted_45 = {
  key: 1,
  class: "m-0"
}
const _hoisted_46 = { class: "orange-color" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Persons have been invited. Invite ")
const _hoisted_48 = { class: "orange-color" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" more person to unlock the reward.")
const _hoisted_50 = {
  key: 2,
  class: "m-0"
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" 有效邀请")
const _hoisted_52 = { class: "orange-color" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("人，再邀请")
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "orange-color" }, "1", -1)
const _hoisted_55 = /*#__PURE__*/_createTextVNode("人可得")
const _hoisted_56 = { class: "orange-color" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode("积分")
const _hoisted_58 = {
  key: 3,
  class: "m-0"
}
const _hoisted_59 = /*#__PURE__*/_createTextVNode(" Invite")
const _hoisted_60 = /*#__PURE__*/_createElementVNode("span", { class: "orange-color" }, /*#__PURE__*/_toDisplayString(' 1 '), -1)
const _hoisted_61 = /*#__PURE__*/_createTextVNode("more friend to earn")
const _hoisted_62 = { class: "orange-color" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode("points! (")
const _hoisted_64 = { class: "orange-color" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("invited so far)")
const _hoisted_66 = { class: "section section-3 rounded-3 mb-3" }
const _hoisted_67 = { class: "tabs d-flex" }
const _hoisted_68 = { class: "items-content d-flex mt-3 flex-wrap justify-content-between" }
const _hoisted_69 = { class: "item-sec3" }
const _hoisted_70 = { class: "value-it3" }
const _hoisted_71 = { class: "label-it3" }
const _hoisted_72 = { class: "item-sec3" }
const _hoisted_73 = { class: "value-it3" }
const _hoisted_74 = { class: "label-it3" }
const _hoisted_75 = { class: "item-sec3" }
const _hoisted_76 = { class: "value-it3" }
const _hoisted_77 = { class: "label-it3" }
const _hoisted_78 = { class: "item-sec3" }
const _hoisted_79 = { class: "value-it3" }
const _hoisted_80 = { class: "label-it3" }
const _hoisted_81 = { class: "section section-2 rounded-3 mb-3 px-0" }
const _hoisted_82 = { class: "title-container-2 d-flex align-items-center flex-wrap mx-3" }
const _hoisted_83 = {
  key: 0,
  class: "title-section-2 me-1"
}
const _hoisted_84 = {
  key: 1,
  src: _imports_9,
  alt: "本月福利",
  class: "me-1 title-section-2-img title-section-2"
}
const _hoisted_85 = { class: "title-note-2" }
const _hoisted_86 = { class: "list-of-gifts overflow-auto px-3" }
const _hoisted_87 = { class: "gift-element d-flex pb-3" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "gift-part-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex rounded-circle list-gifts-icon-parent d-flex align-items-center justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "list-gifts-icon",
      src: _imports_10,
      alt: "recharge-rebate"
    })
  ])
], -1)
const _hoisted_89 = { class: "gift-part-2 me-2 list-gifts-content text-start" }
const _hoisted_90 = { class: "list-gifts-title" }
const _hoisted_91 = { class: "list-gifts-des" }
const _hoisted_92 = { class: "m-0" }
const _hoisted_93 = { class: "m-0 mt-1" }
const _hoisted_94 = { class: "gift-part-3 ms-auto" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("div", { class: "gift-part-1 me-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex rounded-circle list-gifts-icon-parent d-flex align-items-center justify-content-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "list-gifts-icon-2",
      src: _imports_4,
      alt: "gift"
    })
  ])
], -1)
const _hoisted_96 = { class: "gift-part-2 me-2 list-gifts-content text-start" }
const _hoisted_97 = { class: "list-gifts-title d-flex flex-wrap" }
const _hoisted_98 = { class: "me-1" }
const _hoisted_99 = { class: "current-points-balance" }
const _hoisted_100 = { class: "list-gifts-des" }
const _hoisted_101 = { class: "m-0" }
const _hoisted_102 = { class: "gift-part-3 ms-auto" }
const _hoisted_103 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tips = _resolveComponent("tips")!
  const _component_mask_layer = _resolveComponent("mask-layer")!
  const _component_Fade = _resolveComponent("Fade")!
  const _component_dialog_share_tips = _resolveComponent("dialog-share-tips")!
  const _component_dialog_save_image = _resolveComponent("dialog-save-image")!
  const _component_dialog_save_image_error = _resolveComponent("dialog-save-image-error")!
  const _component_dialog_referral_rewards = _resolveComponent("dialog-referral-rewards")!
  const _component_dialog_share_code = _resolveComponent("dialog-share-code")!
  const _component_dialog_rewards_records = _resolveComponent("dialog-rewards-records")!
  const _component_slide_down = _resolveComponent("slide-down")!
  const _component_dialog_apply_gift = _resolveComponent("dialog-apply-gift")!
  const _component_dialog_success_gift = _resolveComponent("dialog-success-gift")!
  const _component_dialog_reward_rules = _resolveComponent("dialog-reward-rules")!
  const _component_screen_shot = _resolveComponent("screen-shot")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["share-header d-flex custom-fs-18 px-3 pb-3", [$setup.getAgentType===1?'pth-android':$setup.getAgentType===2? 'pth-ios':'']])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            role: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeTab_())),
            src: _imports_0,
            alt: "back"
          })
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString($setup.local.share_title), 1),
        _createElementVNode("button", {
          class: "share-header-e border-0 text-end text-white bg-transparent reward-rules-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openComponent('isRewardRulesDialog')))
        }, _toDisplayString($setup.local.rewards_rules), 1)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          ($setup.langQuery == 'en')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.local.share_2), 1))
            : (_openBlock(), _createElementBlock("img", _hoisted_7)),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                ($setup.langQuery == 'en')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.local.title_section_1), 1))
                  : (_openBlock(), _createElementBlock("img", _hoisted_14)),
                _createElementVNode("div", _hoisted_15, _toDisplayString($setup.getFormatedMonthsReward($setup.langQuery)), 1)
              ]),
              _createElementVNode("button", {
                class: "reward-records-btn border-0 bg-transparent",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openComponent('isDialogRewardsRecords')))
              }, _toDisplayString($setup.local.reward_records_btn), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString($setup.local.sp1), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString($setup.local.sp2) + _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + _toDisplayString($setup.local.sp2_com), 1)
              ]),
              _createElementVNode("p", _hoisted_20, _toDisplayString($setup.local.invint_note), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", {
                  class: "progress-line rounded-3",
                  style: _normalizeStyle({width:$setup.getCurrentWidth+'%'})
                }, null, 4),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["gift gift-1 rounded-circle", [($setup.filteredGifts[0] && ($setup.filteredGifts[0].referrals<$setup.nextStep))?'received-gift':'next-gift']])
                }, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString($setup.filteredGifts[0]? $setup.filteredGifts[0].referrals : '') + _toDisplayString($setup.local.invites), 1),
                  _withDirectives(_createElementVNode("div", {
                    ref: "leftLabelRef",
                    class: _normalizeClass(["orange-label-middle rounded-5 p-1 position-absolute", [$setup.getLabelStyleMode === 'left' ? 'orange-label-left' : $setup.getLabelStyleMode === 'middle' ? '' : 'orange-label-left-reverse']])
                  }, _toDisplayString($setup.currentLabel || '-----'), 3), [
                    [_vShow, $setup.filteredGifts[0] && ($setup.nextStep === $setup.filteredGifts[0].referrals)]
                  ])
                ], 2), [
                  [_vShow, $setup.filteredGifts[0] !== null]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["gift gift-2 rounded-circle", [($setup.filteredGifts[1] && $setup.filteredGifts[1].referrals<$setup.nextStep)?'received-gift':'next-gift']])
                }, [
                  _hoisted_25,
                  _createElementVNode("div", _hoisted_26, _toDisplayString($setup.filteredGifts[1] ? $setup.filteredGifts[1].referrals : '') + _toDisplayString($setup.local.invites), 1),
                  _withDirectives(_createElementVNode("div", { class: "orange-label-middle rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                    [_vShow, $setup.filteredGifts[1] && ($setup.nextStep === $setup.filteredGifts[1].referrals)]
                  ])
                ], 2), [
                  [_vShow, $setup.filteredGifts[1] !== null]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["gift gift-3 rounded-circle", [($setup.filteredGifts[2] && $setup.filteredGifts[2].referrals<$setup.nextStep)?'received-gift':'next-gift']])
                }, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, _toDisplayString($setup.filteredGifts[2] ? $setup.filteredGifts[2].referrals : '') + _toDisplayString($setup.local.invites), 1),
                  _withDirectives(_createElementVNode("div", { class: "orange-label-middle rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                    [_vShow, $setup.filteredGifts[2] && ($setup.nextStep === $setup.filteredGifts[2].referrals)]
                  ])
                ], 2), [
                  [_vShow, $setup.filteredGifts[2] !== null]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["gift gift-4 rounded-circle", [($setup.filteredGifts[3] && $setup.filteredGifts[3].referrals<$setup.nextStep)?'received-gift':'next-gift']])
                }, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, _toDisplayString($setup.filteredGifts[3] ? $setup.filteredGifts[3].referrals : '') + _toDisplayString($setup.local.invites), 1),
                  _withDirectives(_createElementVNode("div", { class: "orange-label-middle rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                    [_vShow, $setup.filteredGifts[3] && ($setup.nextStep === $setup.filteredGifts[3].referrals)]
                  ])
                ], 2), [
                  [_vShow, $setup.filteredGifts[3] !== null]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: _normalizeClass(["gift gift-5 rounded-circle", [($setup.filteredGifts[4] && $setup.filteredGifts[4].referrals<$setup.nextStep)?'received-gift':'next-gift']])
                }, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, _toDisplayString($setup.filteredGifts[4] ? $setup.filteredGifts[4].referrals : '') + _toDisplayString($setup.local.invites), 1),
                  _withDirectives(_createElementVNode("div", { class: "orange-label-middle rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                    [_vShow, $setup.filteredGifts[4] && ($setup.nextStep === $setup.filteredGifts[4].referrals)]
                  ])
                ], 2), [
                  [_vShow, $setup.filteredGifts[4] !== null]
                ]),
                ($setup.filteredGifts[4])
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["gift gift-6 rounded-circle", [($setup.filteredGifts[4] && $setup.filteredGifts[4].referrals+1<$setup.nextStep)?'received-gift':'next-gift']])
                    }, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString($setup.filteredGifts[4] ? $setup.filteredGifts[4].referrals : '') + "+", 1),
                      _withDirectives(_createElementVNode("div", { class: "orange-label-middle orange-label-right rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                        [_vShow, $setup.filteredGifts[4] && $setup.nextStep>=($setup.filteredGifts[4].referrals+1)]
                      ])
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["gift gift-6 rounded-circle", [($setup.filteredGifts[0] && $setup.filteredGifts[0].referrals+1<$setup.nextStep)?'received-gift':'next-gift']])
                    }, [
                      _hoisted_35,
                      _createElementVNode("div", _hoisted_36, _toDisplayString($setup.filteredGifts[0] ? $setup.filteredGifts[0].referrals : '') + "+", 1),
                      _withDirectives(_createElementVNode("div", { class: "orange-label-middle orange-label-right rounded-5 p-1 position-absolute" }, _toDisplayString($setup.currentLabel || '-----'), 513), [
                        [_vShow, $setup.filteredGifts[0] && $setup.nextStep>=($setup.filteredGifts[0].referrals+1)]
                      ])
                    ], 2))
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              ($setup.langQuery == 'cn' && $setup.shareInfo.sharesThisMonth.total_active_invites<$setup.shareInfo.MaxReferralsOfAvailableGifts)
                ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("span", _hoisted_41, _toDisplayString($setup.shareInfo.sharesThisMonth.total_active_invites), 1),
                    _hoisted_42,
                    _createElementVNode("span", _hoisted_43, _toDisplayString($setup.nextStep-$setup.shareInfo.sharesThisMonth.total_active_invites), 1),
                    _hoisted_44
                  ]))
                : _createCommentVNode("", true),
              ($setup.langQuery != 'cn' &&$setup.shareInfo.sharesThisMonth.total_active_invites<$setup.shareInfo.MaxReferralsOfAvailableGifts)
                ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                    _createElementVNode("span", _hoisted_46, _toDisplayString($setup.shareInfo.sharesThisMonth.total_active_invites), 1),
                    _hoisted_47,
                    _createElementVNode("span", _hoisted_48, _toDisplayString($setup.nextStep-$setup.shareInfo.sharesThisMonth.total_active_invites), 1),
                    _hoisted_49
                  ]))
                : _createCommentVNode("", true),
              ($setup.langQuery == 'cn' && $setup.shareInfo.sharesThisMonth.total_active_invites>=$setup.shareInfo.MaxReferralsOfAvailableGifts)
                ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("span", _hoisted_52, _toDisplayString($setup.shareInfo.sharesThisMonth.total_active_invites), 1),
                    _hoisted_53,
                    _hoisted_54,
                    _hoisted_55,
                    _createElementVNode("span", _hoisted_56, _toDisplayString($setup.shareInfo.extraGiftedPoints), 1),
                    _hoisted_57
                  ]))
                : _createCommentVNode("", true),
              ($setup.langQuery != 'cn' && $setup.shareInfo.sharesThisMonth.total_active_invites>=$setup.shareInfo.MaxReferralsOfAvailableGifts)
                ? (_openBlock(), _createElementBlock("p", _hoisted_58, [
                    _hoisted_59,
                    _hoisted_60,
                    _hoisted_61,
                    _createElementVNode("span", _hoisted_62, _toDisplayString(' '+$setup.shareInfo.extraGiftedPoints+' '), 1),
                    _hoisted_63,
                    _createElementVNode("span", _hoisted_64, _toDisplayString($setup.shareInfo.sharesThisMonth.total_active_invites+' '), 1),
                    _hoisted_65
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab me-3", [$setup.currentTab === 'tab1' ? 'tab-active' : '',$setup.langQuery == 'en'? 'tab-en-active':'']]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab('tab1')))
              }, [
                ($setup.langQuery == 'cn')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: _normalizeClass(["tab-image", [$setup.currentTab === 'tab1' ? 'tab-img-active' : '']]),
                      src: _imports_7,
                      alt: "monthly"
                    }, null, 2))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: _normalizeClass(["m-0 tab-text", [$setup.currentTab === 'tab1' ? 'tab-text-active' : '']])
                    }, "Monthly", 2))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab", [$setup.currentTab === 'tab2' ? 'tab-active' : '',$setup.langQuery == 'en'? 'tab-en-active':'']]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab('tab2')))
              }, [
                ($setup.langQuery == 'cn')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: _normalizeClass(["tab-image", [$setup.currentTab === 'tab2' ? 'tab-img-active' : '']]),
                      src: _imports_8,
                      alt: "half-year"
                    }, null, 2))
                  : (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: _normalizeClass(["m-0 tab-text", [$setup.currentTab === 'tab2' ? 'tab-text-active' : '']])
                    }, "Biannual", 2))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, _toDisplayString($setup.currentDataTab.total_invites || '--'), 1),
                _createElementVNode("div", _hoisted_71, _toDisplayString($setup.local.item_sec3_1), 1)
              ]),
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, _toDisplayString($setup.currentDataTab.total_active_invites || '--'), 1),
                _createElementVNode("div", _hoisted_74, _toDisplayString($setup.local.item_sec3_2), 1)
              ]),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, _toDisplayString($setup.currentPointsMode.sharePointsIn || '--'), 1),
                _createElementVNode("div", _hoisted_77, _toDisplayString($setup.local.item_sec3_3), 1)
              ]),
              _createElementVNode("div", _hoisted_78, [
                _createElementVNode("div", _hoisted_79, _toDisplayString($setup.currentPointsMode.purchasePointsIn || '--'), 1),
                _createElementVNode("div", _hoisted_80, _toDisplayString($setup.local.item_sec3_4), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createElementVNode("div", _hoisted_82, [
              ($setup.langQuery == 'en')
                ? (_openBlock(), _createElementBlock("div", _hoisted_83, _toDisplayString($setup.local.title_section_2), 1))
                : (_openBlock(), _createElementBlock("img", _hoisted_84)),
              _createElementVNode("div", _hoisted_85, _toDisplayString($setup.local.title_note_2), 1)
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", _hoisted_90, _toDisplayString($setup.local.list_gifts_title1) + _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + "%", 1),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("p", _hoisted_92, _toDisplayString($setup.local.list_gifts_des11) + _toDisplayString($setup.shareInfo.share_rebate[0].new_purchase_percent) + _toDisplayString($setup.local.list_gifts_des11_com), 1),
                    _createElementVNode("p", _hoisted_93, _toDisplayString($setup.local.list_gifts_des12), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.toggleComponent('isDialogShareCode'))),
                    class: _normalizeClass(["gift-btn toInv-btn border-0", [$setup.langQuery == 'en' ? 'en-gift-btn-w' : '']])
                  }, _toDisplayString($setup.local.to_invite), 3)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.giftsList, (gift, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "gift-element d-flex position-relative gift-element-2 py-3",
                  key: index
                }, [
                  _hoisted_95,
                  _createElementVNode("div", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, [
                      _createElementVNode("div", _hoisted_98, _toDisplayString(gift?.title), 1),
                      _createElementVNode("div", _hoisted_99, _toDisplayString(gift?.id === 'pm350'? $setup.currentPointsBalance > 0 ? $setup.local.current_points_b1+$setup.currentPointsBalance+$setup.local.current_points_b2 : '': ''), 1)
                    ]),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("p", _hoisted_101, _toDisplayString(gift?.description), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    (gift?.state === 's2')
                      ? (_openBlock(), _createElementBlock("button", {
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleComponent('isDialogShareCode'))),
                          class: _normalizeClass(["gift-btn toInv-btn border-0", [$setup.langQuery == 'en' ? 'en-gift-btn-w' : '']]),
                          key: index
                        }, _toDisplayString($setup.local.to_invite), 3))
                      : _createCommentVNode("", true),
                    (gift?.state === 's1')
                      ? (_openBlock(), _createElementBlock("button", {
                          onClick: ($event: any) => ($setup.applyGifts(gift)),
                          key: index,
                          class: _normalizeClass(["gift-btn get-rewards-btn border-0", [$setup.langQuery == 'en' ? 'en-gift-btn-w' : '']])
                        }, _toDisplayString($setup.local.get_rewards), 11, _hoisted_103))
                      : _createCommentVNode("", true),
                    (gift?.state === 's3')
                      ? (_openBlock(), _createElementBlock("button", {
                          onClick: _cache[7] || (_cache[7] = () => _ctx.console.log('')),
                          disabled: "",
                          class: _normalizeClass(["gift-btn recieved-btn border-0", [$setup.langQuery == 'en' ? 'en-gift-btn-w' : '']]),
                          key: index
                        }, _toDisplayString($setup.local.received), 3))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createVNode(_component_tips, { ref: "tipsRef" }, null, 512),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_mask_layer, null, null, 512), [
            [_vShow, $setup.saveImage || $setup.state.isCopiedLink || $setup.state.isReferralRewards || $setup.state.showLoading || $setup.state.isDialogShareCode || $setup.state.isDialogRewardsRecords || $setup.state.isApplyGiftDialog || $setup.state.isSuccessDialog || $setup.state.isRewardRulesDialog]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_share_tips, {
            onHide: _cache[8] || (_cache[8] = ($event: any) => ($setup.toggleComponent('isCopiedLink')))
          }, null, 512), [
            [_vShow, $setup.state.isCopiedLink]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_save_image, {
            onHide: _cache[9] || (_cache[9] = ($event: any) => ($setup.closeSaveImageDialog()))
          }, null, 512), [
            [_vShow, $setup.saveImage === 1]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_save_image_error, {
            onHide: _cache[10] || (_cache[10] = ($event: any) => ($setup.closeSaveImageDialog()))
          }, null, 512), [
            [_vShow, $setup.saveImage === 2]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_referral_rewards, {
            onHide: _cache[11] || (_cache[11] = ($event: any) => ($setup.toggleComponent('isReferralRewards')))
          }, null, 512), [
            [_vShow, $setup.state.isReferralRewards]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          (!$setup.state.isCopiedLink && !$setup.saveImage && $setup.state.isDialogShareCode)
            ? (_openBlock(), _createBlock(_component_dialog_share_code, {
                key: 0,
                invCode: $setup.shareInfo.inviteCode,
                onClose_: _cache[12] || (_cache[12] = ($event: any) => ($setup.toggleComponent('isDialogShareCode'))),
                onCopyLink_: _cache[13] || (_cache[13] = ($event: any) => ($setup.copyLink())),
                onTakeImage_: _cache[14] || (_cache[14] = ($event: any) => ($setup.captureScreenshot().finally(()=>$setup.takeScreenisDone()))),
                onCopyCode_: _cache[15] || (_cache[15] = (value) => $setup.copyCode(value))
              }, null, 8, ["invCode"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_slide_down, { name: "fade-down" }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_rewards_records, {
            onHide: _cache[16] || (_cache[16] = ($event: any) => ($setup.closeComponent('isDialogRewardsRecords'))),
            showDialog: $setup.state.isDialogRewardsRecords,
            encryptedToken: $setup.data.encryptedToken
          }, null, 8, ["showDialog", "encryptedToken"]), [
            [_vShow, $setup.state.isDialogRewardsRecords]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_apply_gift, {
            onHide: _cache[17] || (_cache[17] = ($event: any) => ($setup.closeComponent('isApplyGiftDialog'))),
            gift: $setup.data.selectedGift,
            onSubmitGiftType: _cache[18] || (_cache[18] = (type,id) => $setup.submitGift(type,id))
          }, null, 8, ["gift"]), [
            [_vShow, $setup.state.isApplyGiftDialog]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_success_gift, {
            onKnew: _cache[19] || (_cache[19] = ($event: any) => ($setup.closeComponent('isSuccessDialog')))
          }, null, 512), [
            [_vShow, $setup.state.isSuccessDialog]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Fade, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_dialog_reward_rules, {
            onHide: _cache[20] || (_cache[20] = ($event: any) => ($setup.closeComponent('isRewardRulesDialog')))
          }, null, 512), [
            [_vShow, $setup.state.isRewardRulesDialog]
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_screen_shot, { ref: "screenShotRef" }, null, 512),
    _withDirectives(_createVNode(_component_Spinner, null, null, 512), [
      [_vShow, $setup.state.showLoading]
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}